import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import convertAmountToText from '../../../../data/AmountToWord';
import { ORDER_STATUS, PAYMENT_STATUS } from '../../../../data/constant';

export default function InvoiceTable(props) {

     const { t } = useTranslation();
     const [sameState, setSameState] = useState(0);

     const { products, order, company, customer, title } = props;

     const thStyle = { padding: "9px", verticalAlign: "center", fontSize: "13px", fontWeight:"500" };
     const footerStyle = { lineHeight: 1, verticalAlign: "center", fontSize: "13px", color: "#3a3030" ,fontWeight:"500"};
     const fontSize = { fontSize: "13px", color: "#3a3030", fontWeight: "500" }

     const headers = ['s_no', 'product', 'hsn_sac', 'price', 'qty', 'discount', 'taxable_value', 'amount'];

     useEffect(() => {
          if (order?.state && company?.state) {
               if (order.state === company.state) {
                    setSameState(1);
               } else {
                    setSameState(0);
               }
          }
     }, [order, company]);

     const dynamicHeaders = sameState === 1
          ? [...headers.slice(0, 7), 'cgst', 'sgst', ...headers.slice(7)]
          : [...headers.slice(0, 7), 'igst', ...headers.slice(7)];

     return (
          <div className='container-fluid'>
               <div className='row'>
                    <table className="table table-bordered">
                         <thead>
                              <tr className='text-center'>
                                   {dynamicHeaders.map((header, index) => (
                                        <th style={thStyle} key={index}>{t(header)}</th>
                                   ))}
                              </tr>
                         </thead>
                         <tbody>
                              {
                                   products.map((product, index) => (
                                        <tr key={index}>
                                             <td style={thStyle}>{index + 1}</td>
                                             <td style={{ width: "200px", ...thStyle }}>{product.product_name} <br /><small>{product.description}</small></td>
                                             <td style={thStyle}>{product.sac}</td>
                                             <td className='text-right' style={thStyle}>{product.price}</td>
                                             <td className='text-right' style={thStyle}>{product.quantity}</td>
                                             <td className='text-right' style={thStyle}>{product.discount_amount} <br /><small>{product.discount} {product.discountType === "1" ? '%' : 'Rs'}</small></td>
                                             <td className='text-right' style={thStyle}>{product.taxable_amount}</td>
                                             {
                                                  sameState === 1 ? (
                                                       <>
                                                            <td className='text-right'><small>{(product.tax_amount / 2).toFixed(2)} <br />{(product.tax / 2).toFixed(2)} % </small></td>
                                                            <td className='text-right'><small>{(product.tax_amount / 2).toFixed(2)} <br />{(product.tax / 2).toFixed(2)} % </small></td>
                                                       </>
                                                  ) : (
                                                       <td className='text-right'><small>{product.tax_amount} <br />{product.tax} % </small></td>
                                                  )
                                             }
                                             <td className='text-right' style={thStyle}>{product.net_amount}</td>
                                        </tr>
                                   )
                                   )
                              }
                         </tbody>
                         <tfoot>
                              <tr>
                                   <td style={thStyle} colSpan="3">{t('total')}</td>
                                   <td style={thStyle} className="text-right">{order.total_price_amount}</td>
                                   <td></td>
                                   <td style={thStyle} className="text-right">{order.total_discount_amount}</td>
                                   <td style={thStyle} className="text-right">{order.total_taxable_amount}</td>
                                   {
                                        sameState === 1 ? (
                                             <>
                                                  <td style={thStyle} className='text-right'>{(order.total_tax_amount / 2).toFixed(2)}</td>
                                                  <td style={thStyle} className='text-right'>{(order.total_tax_amount / 2).toFixed(2)}</td>
                                             </>
                                        ) : (
                                             <td style={thStyle} className="text-right">{order.total_tax_amount}</td>
                                        )
                                   }

                                   <td style={thStyle} className="text-right">{order.net_amount}</td>
                              </tr>
                         </tfoot>
                    </table>
               </div>
               <div className='row mt-2'>
                    <div className='col-6'>
                         {title === 'bill_to' && company && (
                              <span style={fontSize}>
                                   {t('bank_name')} : {company.bank_name}<br />
                                   {t('account_number')} : {company.account_number}<br />
                                   {t('ifsc')} : {company.ifsc}<br />
                                   {t('branch')} : {company.branch}<br />
                                   {t('upi_id')} : {company.upi_id}
                              </span>
                         )}
                         {title === 'vendor' && ORDER_STATUS[order.status] && (
                              <p style={fontSize}>
                                   {t('status')} : <span className={ORDER_STATUS[order.status].colorClass}>{t(ORDER_STATUS[order.status].name)}</span>
                              </p>
                         )}
                         {title === 'bill_to' && PAYMENT_STATUS[order.payment_status] && (
                              <p style={fontSize}>
                                   {t('payment_status')} : <span className={PAYMENT_STATUS[order.payment_status].colorClass}>{t(PAYMENT_STATUS[order.payment_status].name)}</span>
                              </p>
                         )}

                    </div>
                    <div className='col-6'>
                         <table className='table table-sm table-borderless'>
                              <tbody>
                                   <tr>
                                        <td className='text-right' style={footerStyle}>{t('total_amount')} : </td>
                                        <td style={footerStyle} className='text-right'>{order.total_price_amount}</td>
                                   </tr>
                                   <tr>
                                        <td className='text-right' style={footerStyle}>{t('discount')} : </td>
                                        <td style={footerStyle} className='text-right'>{order.total_discount_amount}</td>
                                   </tr>
                                   <tr>
                                        <td className='text-right' style={footerStyle}>{t('total_taxable')} : </td>
                                        <td style={footerStyle} className='text-right'>{order.total_taxable_amount}</td>
                                   </tr>
                                   <tr>
                                        <td className='text-right' style={footerStyle}>{t('total_tax')} : </td>
                                        <td style={footerStyle} className='text-right'>{order.total_tax_amount}</td>
                                   </tr>
                                   <tr>
                                        <td className='text-right text-primary' style={footerStyle} >{t('net_amount_in_figure')} :</td>
                                        <td style={footerStyle} className='text-right text-primary'>{order.net_amount}</td>
                                   </tr>
                                   {title === 'bill_to' && parseFloat(order.paid_amount) > 0 && (
                                        <tr>
                                             <td className='text-right text-success' style={footerStyle} >{t('paid_amount')} :</td>
                                             <td style={footerStyle} className='text-right text-success'>{order.paid_amount}</td>
                                        </tr>
                                   )}
                                   {title === 'bill_to' && parseFloat(order.pending_amount) > 0 && (
                                        <tr>
                                             <td className='text-right text-danger' style={footerStyle} >{t('pending_amount')} :</td>
                                             <td style={footerStyle} className='text-right text-danger'>{order.pending_amount}</td>
                                        </tr>
                                   )}
                              </tbody>
                         </table>
                    </div>
               </div>
               <div className='mt-2 p-1 float-right bg-primary text-white'>
                    <span style={{ ...footerStyle, color: "white" }}>
                         {t('net_amount_in_words')} : {order.net_amount !== undefined ? convertAmountToText(order.net_amount) : ''}
                    </span>
               </div>
               <div className='row mt-3'>
                    <div>
                         <p className='p-0 m-0' style={fontSize}>{t('terms_conditions')}</p>
                         <i className='p-0' style={fontSize}>
                              {order.terms_conditions}
                         </i>
                    </div>
               </div>
          </div>
     )
}
